module.exports = __webpack_public_path__ + "img/4m.fc5481e4.png";